exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active,\n.slide-leave-active {\n  position: absolute;\n  transition: all 0.3s ease-in-out;\n}\n.slide-leave-active {\n  right: 16px;\n}\n.slide-enter {\n  position: absolute;\n  transform: translateX(100%);\n}\n.slide-enter-to {\n  position: absolute;\n  transform: translateX(0);\n}\n.slide-leave-to {\n  position: absolute;\n  transform: translateX(-100%);\n}\n.slide-leave {\n  position: absolute;\n  transform: translateX(0);\n}", ""]);

// exports
